import React from 'react'
import { TrainingPackageLoader } from 'loaders'
import PropTypes from 'prop-types'
import TrainingPackageEditContainer from './TrainingPackageEditContainer'

const TrainingPackageEdit = ({
  history,
  match: {
    params: { trainingPackageUuid },
  },
  match,
  location,
}) => (
  <TrainingPackageLoader
    trainingPackageUuid={trainingPackageUuid}
    additionalFields={['drills']}
  >
    <TrainingPackageEditContainer
      history={history}
      match={match}
      location={location}
    />
  </TrainingPackageLoader>
)

TrainingPackageEdit.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      trainingPackageUuid: PropTypes.string.isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,

  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default TrainingPackageEdit
